import React from 'react';

const NoResultsPage = () => {
  return (
    <div className="min-h-[80vh] bg-gray-50 flex flex-col justify-center items-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-md p-8 text-center">
        {/* Icon */}
        <div className="mb-6">
          <svg 
            className="w-24 h-24 mx-auto text-gray-300" 
            fill="#15803d" 
            stroke="#000" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth="1.5" 
              d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            ></path>
          </svg>
        </div>
        
        {/* Text Content */}
        <h2 className="text-2xl font-bold text-[#15803d] mb-2">No Results Found</h2>
        <p className="text-gray-600 mb-6">
          We couldn't find any data matching your criteria. Try adjusting your search or filter parameters.
        </p>
        
        
      </div>
      

    </div>
  );
};

export default NoResultsPage;